import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from './util/invalidateQuery';

const refundPolicyDeactivateExchange: UpdatesConfig['Mutation'] = {
  refundPolicyDeactivate: (_: Data, __: Variables, cache: Cache) => invalidateQuery(
    ['refundPolicyByImplementationId'],
    cache,
  ),
};

export default refundPolicyDeactivateExchange;
